import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-primary-div bg-opacity-25 border-0 rounded-3 p-4 mb-4 overflow-hidden" }
const _hoisted_2 = { style: {"margin":"-16px -35px -80px -38px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<span class=\"d-block mb-3\" style=\"color:#526077;\">Overall Visitors</span><div class=\"d-flex align-items-center\"><h3 class=\"fs-24 fw-medium mb-0\">45,745</h3><span class=\"d-inline-block px-2 text-success border-success border rounded-pill bg-opacity-25 fs-12 fw-medium ms-2\" style=\"background-color:#d8ffc8;\"><i class=\"ri-arrow-up-fill\"></i> 7% </span></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "area",
            height: "160",
            options: _ctx.overallVisitors,
            series: _ctx.visitors
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}